import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API } from '../../shared/constants/app-service-constants';
import { CachSizeOption, ApplicationSettings } from './store/application-settings.reducer';

@Injectable({ providedIn: 'root' })
export class ApplicationSettingsService {
  constructor(private http: HttpClient) {}

  loadApplicationSettings(): Observable<ApplicationSettings> {
    return this.http.get<ApplicationSettings>(
      `${API.USER_SETTINGS_INFO}?loadApplicationSettings=true`,
    );
  }

  getCacheSize(): Observable<CachSizeOption[]> {
    return this.http.get<CachSizeOption[]>(API.OFFLINE_CACHE_SIZE);
  }

  updateCacheSize(size): Observable<any> {
    return this.http.post(`${API.UPDATE_CACHE_SIZE}?size=${size}`, {});
  }

  setWifiOnly(wifiOnly: boolean): Observable<any> {
    return this.http.post(
      `${API.USER_SETTINGS}/updateOfflineNetworkSettings?isWifiOnly=${wifiOnly}`,
      {},
    );
  }

  setOfflineCache(isCache: boolean): Observable<any> {
    return this.http.post(
      `${API.USER_SETTINGS}/updateOfflineCacheSettings?isOfflineCacheEnabled=${isCache}`,
      {},
    );
  }
}
